/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.market.optimistic.js
Source: slb_src/slices/market/
Build: slb_build/build_market.mjs
Built: 2026-09-19 16:53:58.177Z
Content-SHA256: 6626d8adb4f9510815ca7f214b4441a7ea1698fd1397f387466423d014ace13d
Content-SHA256-12: 6626d8adb4f9
*/

/* MIGRATED SOURCE
   Original asset: /assets/slb.market.optimistic.js
   Note: This file was copied as-is to bring the module under the slice build pipeline.
   Safe refactor can be done later by splitting into multiple numbered parts.
*/

/* SLB Market Optimistic UI Patch (Option 2 - separate file)
   - Instant UI + background sync + failed/resync
   - Covers: Offer, Market, Orders, Sales
*/
(function(){
  if(window.__SLB_MARKET_OPT_V2__) return;
  window.__SLB_MARKET_OPT_V2__ = true;

  const LS_KEY = 'slb_market_queue_v1';
  const SYNC_RESULT_FLASH_MS = 1600;

  // Safety nets (prevents the UI from staying forever at "Action queued (syncing…)" if a JSONP call never returns)
  const STUCK_MS = 70000;       // after this long in "syncing", mark as failed
  const CALL_TIMEOUT_MS = 65000; // wrapper timeout around a queued call

  function now(){ return Date.now(); }
  function genId(){ return 'm' + now() + '_' + Math.random().toString(16).slice(2); }

  function withTimeout(promise, ms, errMsg){
    return new Promise((resolve, reject) => {
      let t = setTimeout(() => reject(new Error(errMsg || 'Timeout')), ms);
      Promise.resolve(promise).then(
        v => { clearTimeout(t); resolve(v); },
        e => { clearTimeout(t); reject(e); }
      );
    });
  }

  function safeJsonParse(s, fallback){
    try{ return JSON.parse(s); }catch(_e){ return fallback; }
  }
  function loadQueue(){
    const raw = localStorage.getItem(LS_KEY);
    const q = safeJsonParse(raw, []);
    return Array.isArray(q) ? q : [];
  }
  function saveQueue(q){
    try{ localStorage.setItem(LS_KEY, JSON.stringify(q)); }catch(_e){}
  }

  function getApi(){ return window.SLB_APP || null; }
  function hasApi(){
    const api = getApi();
    return !!(api && api.rpc && api.rpcTryCached && api.S && api.P3);
  }

  function el(id){ return document.getElementById(id); }

  // ===== Queue inspector (so you can see what failed and clear it) =====
  function ensureQueueStyle(){
    if(document.getElementById('slbMktQueueStyle')) return;
    const st = document.createElement('style');
    st.id = 'slbMktQueueStyle';
    st.textContent = `
      .slbMktQueueBar{display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin:6px 0 0;}
      .slbMktQueueBar .btn{padding:6px 10px;}
      .slbMktQOverlay{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9999;display:flex;align-items:flex-start;justify-content:center;padding:24px;}
      .slbMktQModal{background:#fff;color:#111;max-width:860px;width:100%;border-radius:14px;box-shadow:0 10px 30px rgba(0,0,0,.25);overflow:hidden;}
      .slbMktQHead{display:flex;justify-content:space-between;align-items:center;padding:12px 14px;border-bottom:1px solid rgba(0,0,0,.08);}
      .slbMktQTitle{font-weight:700;}
      .slbMktQBody{padding:12px 14px;max-height:min(70vh,560px);overflow:auto;}
      .slbMktQRow{display:grid;grid-template-columns:120px 110px 1fr 120px;gap:10px;align-items:center;padding:10px 0;border-bottom:1px dashed rgba(0,0,0,.10);}
      .slbMktQRow:last-child{border-bottom:none;}
      .slbMktQSmall{font-size:12px;opacity:.8;}
      .slbMktQTag{display:inline-block;padding:2px 8px;border-radius:999px;font-size:12px;}
      .slbMktQTag.sync{background:rgba(0,128,0,.12);}
      .slbMktQTag.fail{background:rgba(220,0,0,.12);}
      .slbMktQBtns{display:flex;gap:8px;align-items:center;flex-wrap:wrap;padding:12px 14px;border-top:1px solid rgba(0,0,0,.08);}
    `;
    document.head.appendChild(st);
  }

  function buildQueueBar(tabKey){
    const cfg = TAB[tabKey];
    if(!cfg) return;
    const reloadBtn = el(cfg.reload);
    if(!reloadBtn) return;
    const host = reloadBtn.parentElement;
    if(!host) return;
    if(host.querySelector('[data-slb-mkt-qbar="1"]')) return;
    ensureQueueStyle();
    const bar = document.createElement('div');
    bar.className = 'slbMktQueueBar';
    bar.setAttribute('data-slb-mkt-qbar','1');
    const viewBtn = document.createElement('button');
    viewBtn.type = 'button';
    viewBtn.className = 'btn soft mini';
    viewBtn.textContent = 'Queue';
    viewBtn.addEventListener('click', ()=> openQueueModal(tabKey));
    const clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'btn soft mini';
    clearBtn.textContent = 'Clear Failed';
    clearBtn.addEventListener('click', ()=> clearFailed(tabKey));
    bar.appendChild(viewBtn);
    bar.appendChild(clearBtn);
    host.appendChild(bar);
  }

  function clearFailed(tabKey){
    const q = loadQueue();
    const before = q.length;
    const kept = q.filter(it => !(it && it.tab === tabKey && it.state === 'failed'));
    if(kept.length !== before){
      saveQueue(kept);
      updateTabIndicators();
      try{
        const api = getApi();
        if(api){
          if(tabKey==='offer' && api.loadMyOffers) api.loadMyOffers();
          if(tabKey==='market' && api.loadMarket) api.loadMarket();
          if(tabKey==='orders' && api.loadMyOrders) api.loadMyOrders();
          if(tabKey==='sales' && api.loadMySales) api.loadMySales();
        }
      }catch(_e){}
    }
  }

  function prettyAction(it){
    const k = String(it.cacheKey || it.action || '').trim();
    const map = {
      p3_offerCreate:'Post Offer',
      p3_offerToggle:'Enable/Disable',
      p3_offerSetPrice:'Save Offer',
      p3_offerDelete:'Delete Offer',
      p3_orderCreate:'Buy',
      p3_orderCancel:'Cancel Order',
      p3_orderConfirmReceived:'Confirm Received',
      p3_saleAccept:'Accept Sale',
      p3_saleMarkDelivered:'Mark Delivered'
    };
    return map[k] || k || (it.kind==='rpc' ? 'Action' : 'Action');
  }

  function openQueueModal(tabKey){
    ensureQueueStyle();
    const q = loadQueue().filter(it => it && it.tab === tabKey);
    const ov = document.createElement('div');
    ov.className = 'slbMktQOverlay';
    ov.addEventListener('click', (e)=>{ if(e.target === ov) ov.remove(); });

    const modal = document.createElement('div');
    modal.className = 'slbMktQModal';

    const head = document.createElement('div');
    head.className = 'slbMktQHead';
    const title = document.createElement('div');
    title.className = 'slbMktQTitle';
    title.textContent = 'Queue — ' + tabKey.toUpperCase();
    const close = document.createElement('button');
    close.type='button';
    close.className='btn soft mini';
    close.textContent='Close';
    close.addEventListener('click', ()=> ov.remove());
    head.appendChild(title);
    head.appendChild(close);

    const body = document.createElement('div');
    body.className = 'slbMktQBody';
    if(!q.length){
      const empty = document.createElement('div');
      empty.className = 'note';
      empty.textContent = 'No queued actions in this tab.';
      body.appendChild(empty);
    }else{
      q.forEach(it=>{
        const row = document.createElement('div');
        row.className = 'slbMktQRow';
        const st = document.createElement('div');
        const tag = document.createElement('span');
        tag.className = 'slbMktQTag ' + (it.state==='failed' ? 'fail' : 'sync');
        tag.textContent = it.state==='failed' ? 'FAILED' : 'SYNCING';
        st.appendChild(tag);
        const when = document.createElement('div');
        when.className = 'slbMktQSmall';
        const ts = Number(it.createdAt||0);
        when.textContent = ts ? new Date(ts).toLocaleString() : '';
        const act = document.createElement('div');
        act.innerHTML = '<div><b>' + escapeHtml(prettyAction(it)) + '</b></div>' +
          '<div class="slbMktQSmall">' + escapeHtml(String(it.entityId||'')) + '</div>' +
          (it.err ? ('<div class="slbMktQSmall" style="opacity:1;color:#b00000;">' + escapeHtml(it.err) + '</div>') : '');
        const btns = document.createElement('div');
        btns.style.display='flex';
        btns.style.gap='8px';
        btns.style.justifyContent='flex-end';
        const del = document.createElement('button');
        del.type='button';
        del.className='btn soft mini';
        del.textContent='Remove';
        del.addEventListener('click', ()=>{ queueRemove(it.requestId); openQueueModal(tabKey); ov.remove(); });
        btns.appendChild(del);
        if(it.state==='failed'){
          const rs = document.createElement('button');
          rs.type='button';
          rs.className='btn soft mini';
          rs.textContent='Resync';
          rs.addEventListener('click', ()=>{ queueUpdate(it.requestId,{state:'syncing',err:''}); syncNext(true); ov.remove(); });
          btns.appendChild(rs);
        }
        row.appendChild(st);
        row.appendChild(when);
        row.appendChild(act);
        row.appendChild(btns);
        body.appendChild(row);
      });
    }

    const foot = document.createElement('div');
    foot.className = 'slbMktQBtns';
    const clearF = document.createElement('button');
    clearF.type='button';
    clearF.className='btn soft mini';
    clearF.textContent='Clear Failed';
    clearF.addEventListener('click', ()=>{ clearFailed(tabKey); ov.remove(); });
    const clearAll = document.createElement('button');
    clearAll.type='button';
    clearAll.className='btn soft mini';
    clearAll.textContent='Clear All';
    clearAll.addEventListener('click', ()=>{
      const kept = loadQueue().filter(it => !(it && it.tab === tabKey));
      saveQueue(kept);
      updateTabIndicators();
      ov.remove();
    });
    foot.appendChild(clearF);
    foot.appendChild(clearAll);

    modal.appendChild(head);
    modal.appendChild(body);
    modal.appendChild(foot);
    ov.appendChild(modal);
    document.body.appendChild(ov);
  }

  // small html escape for modal
  function escapeHtml(s){
    return String(s||'').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;'}[c]));
  }

  // Tabs mapping to message + reload nodes
  const TAB = {
    offer:  { ok:'tywOfferOk',  err:'tywOfferMsg',  reload:'tywOfferReloadBtn' },
    market: { ok:'tywMarketOk', err:'tywMarketMsg', reload:'tywMarketReloadBtn' },
    orders: { ok:'tywOrdersOk', err:'tywOrdersMsg', reload:'tywOrdersReloadBtn' },
    sales:  { ok:'tywSalesOk',  err:'tywSalesMsg',  reload:'tywSalesReloadBtn' }
  };

  const lastMsg = { offer:{ok:'',err:''}, market:{ok:'',err:''}, orders:{ok:'',err:''}, sales:{ok:'',err:''} };
  let flashTimers = {};

  function setMsg(node, text, isOk){
    const api = getApi();
    if(api && api.setMsg) return api.setMsg(node, text, isOk);
    if(!node) return;
    node.classList.remove('hidden');
    node.classList.toggle('ok', !!isOk);
    node.classList.toggle('err', !isOk);
    node.textContent = String(text||'');
  }
  function clearMsg(node){
    const api = getApi();
    if(api && api.clearMsg) return api.clearMsg(node);
    if(!node) return;
    node.classList.add('hidden');
    node.textContent = '';
    node.classList.remove('ok','err');
  }

  function setReloadLabel(tabKey, label){
    const cfg = TAB[tabKey];
    if(!cfg) return;
    const b = el(cfg.reload);
    if(b) b.textContent = label;
  }

  function countByTab(q){
    const out = { offer:{sync:0,fail:0}, market:{sync:0,fail:0}, orders:{sync:0,fail:0}, sales:{sync:0,fail:0} };
    q.forEach(it=>{
      const t = it.tab;
      if(!out[t]) return;
      if(it.state === 'failed') out[t].fail++;
      else out[t].sync++;
    });
    return out;
  }

  function updateTabIndicators(){
    try{
      const q = loadQueue();
      const c = countByTab(q);

    Object.keys(TAB).forEach(tabKey=>{
      const okNode = el(TAB[tabKey].ok);
      const errNode = el(TAB[tabKey].err);

      // Clear any pending "flash" timer if we are actively showing queued/failed state
      const hasAny = (c[tabKey].sync + c[tabKey].fail) > 0;
      if(hasAny && flashTimers[tabKey]){
        clearTimeout(flashTimers[tabKey]);
        delete flashTimers[tabKey];
      }

      if(c[tabKey].fail > 0){
        const msg = (c[tabKey].fail === 1)
          ? '1 action failed to sync. Click Resync.'
          : (c[tabKey].fail + ' actions failed to sync. Click Resync.');
        if(lastMsg[tabKey].err !== msg){
          clearMsg(okNode);
          setMsg(errNode, msg, false);
          lastMsg[tabKey].err = msg;
          lastMsg[tabKey].ok = '';
        }
        setReloadLabel(tabKey, 'Resync');
        return;
      }

      if(c[tabKey].sync > 0){
        const msg = (c[tabKey].sync === 1)
          ? 'Action queued (syncing…).'
          : (c[tabKey].sync + ' actions queued (syncing…).');
        if(lastMsg[tabKey].ok !== msg){
          clearMsg(errNode);
          setMsg(okNode, msg, true);
          lastMsg[tabKey].ok = msg;
          lastMsg[tabKey].err = '';
        }
        setReloadLabel(tabKey, 'Reload');
        return;
      }

      // Nothing pending in this tab
      if(lastMsg[tabKey].ok || lastMsg[tabKey].err){
        clearMsg(okNode);
        clearMsg(errNode);
        lastMsg[tabKey].ok = '';
        lastMsg[tabKey].err = '';
      }
      setReloadLabel(tabKey, 'Reload');
    });

      applyPendingPills(); // keep UI consistent after any state change
    }catch(_e){ /* never break the app UI */ }
  }

  function flashOk(tabKey, msg){
    const okNode = el(TAB[tabKey].ok);
    const errNode = el(TAB[tabKey].err);
    clearMsg(errNode);
    setMsg(okNode, msg, true);
    lastMsg[tabKey].ok = msg;
    lastMsg[tabKey].err = '';
    if(flashTimers[tabKey]) clearTimeout(flashTimers[tabKey]);
    flashTimers[tabKey] = setTimeout(()=>{
      // Only clear if no pending state exists anymore
      const q = loadQueue();
      const c = countByTab(q);
      if(c[tabKey].sync === 0 && c[tabKey].fail === 0){
        clearMsg(okNode);
        lastMsg[tabKey].ok = '';
      }
      delete flashTimers[tabKey];
    }, SYNC_RESULT_FLASH_MS);
  }

  function flashErr(tabKey, msg){
    const errNode = el(TAB[tabKey].err);
    const okNode = el(TAB[tabKey].ok);
    clearMsg(okNode);
    setMsg(errNode, msg, false);
    lastMsg[tabKey].err = msg;
    lastMsg[tabKey].ok = '';
  }

  function queueAdd(item){
    const q = loadQueue();
    const it = Object.assign({
      state: 'syncing',
      createdAt: now(),
      startedAt: 0,
      err: ''
    }, item || {});
    q.push(it);
    // cap
    while(q.length > 60) q.shift();
    saveQueue(q);
    updateTabIndicators();
    scheduleQueuedWork_(0);
  }

  function queueUpdate(id, patch){
    const q = loadQueue();
    const i = q.findIndex(x => x && x.requestId === id);
    if(i < 0) return;
    q[i] = Object.assign({}, q[i], patch);
    saveQueue(q);
    updateTabIndicators();
    scheduleQueuedWork_(0);
  }

  function queueRemove(id){
    const q = loadQueue().filter(x => x && x.requestId !== id);
    saveQueue(q);
    updateTabIndicators();
    if(hasSyncingQueue_()) scheduleQueuedWork_(0); else stopQueuedWork_();
  }

  function tabHasFailed(tabKey){
    const q = loadQueue();
    return q.some(x => x && x.tab === tabKey && x.state === 'failed');
  }

  function resyncTab(tabKey){
    const q = loadQueue();
    let changed = false;
    q.forEach(it=>{
      if(it && it.tab === tabKey && it.state === 'failed'){
        it.state = 'syncing';
        it.err = '';
        changed = true;
      }
    });
    if(changed){
      saveQueue(q);
      updateTabIndicators();
      syncNext(true);
    }
  }

  // ===== UI pills on rows =====
  function clearAllPills(){
    document.querySelectorAll('[data-slb-mkt-pill]').forEach(n => n.remove());
    document.querySelectorAll('.slbMktRowPending').forEach(n => n.classList.remove('slbMktRowPending'));
    document.querySelectorAll('.slbMktRowFailed').forEach(n => n.classList.remove('slbMktRowFailed'));
    document.querySelectorAll('button[data-slb-mkt-disabled]').forEach(b=>{
      b.removeAttribute('data-slb-mkt-disabled');
      b.disabled = false;
    });
  }

  function insertPill(anchorEl, state, requestId){
    if(!anchorEl) return;
    const pill = document.createElement('span');
    pill.setAttribute('data-slb-mkt-pill','1');
    pill.className = 'pill slbStickyState ' + (state === 'failed' ? 'retry' : 'syncing');
    pill.textContent = (state === 'failed') ? 'Not synced — Resync' : 'Syncing…';
    if(state === 'failed'){
      pill.setAttribute('data-slb-mkt-resync', requestId);
      pill.title = 'Click to resync';
    }
    anchorEl.appendChild(pill);
  }

  function findQueueItemByRequestId(q, requestId){
    const rid = String(requestId || '');
    if(!rid) return null;
    for(const it of (q || [])){
      if(it && String(it.requestId || '') === rid) return it;
    }
    return null;
  }

  function updateTempOrderRows(q){
    const body = el('tywOrdersBody');
    if(!body) return;
    const rows = Array.from(body.querySelectorAll('tr[data-slb-temp-order="1"]'));
    if(!rows.length) return;
    rows.forEach(tr => {
      const rid = tr.getAttribute('data-slb-request') || '';
      const it = findQueueItemByRequestId(q, rid);
      if(!it){
        // Queue item is gone (success or cleared). Remove the temp row.
        tr.remove();
        return;
      }
      tr.classList.add('slbMktRowPending');
      if(it.state === 'failed') tr.classList.add('slbMktRowFailed');
      const statusCell = tr.querySelector('td[data-slb-temp-status="1"]');
      if(statusCell){
        statusCell.textContent = (it.state === 'failed') ? 'FAILED' : 'PLACED';
        insertPill(statusCell, it.state, it.requestId);
      }
    });
  }

  function applyPendingPills(){
    if(!hasApi()) return;
    clearAllPills();

    const q = loadQueue();
    if(!q.length) return;

    // Offer / My offers (tbody buttons)
    const myOffersBody = el('tywMyOffersBody');
    if(myOffersBody){
      q.filter(it=>it.tab==='offer').forEach(it=>{
        const id = String(it.entityId||'');
        if(!id) return;
        // match any action button for this offerId
        const btn = myOffersBody.querySelector(`button[data-edit="${CSS.escape(id)}"],button[data-toggle="${CSS.escape(id)}"],button[data-save="${CSS.escape(id)}"],button[data-del="${CSS.escape(id)}"]`);
        if(!btn) return;
        const tr = btn.closest('tr');
        if(tr){
          tr.classList.add('slbMktRowPending');
          if(it.state==='failed') tr.classList.add('slbMktRowFailed');
        }
        const cell = btn.parentElement;
        if(cell) insertPill(cell, it.state, it.requestId);
        // disable buttons for that row while syncing
        if(it.state==='syncing'){
          tr && tr.querySelectorAll('button').forEach(b=>{
            b.disabled = true;
            b.setAttribute('data-slb-mkt-disabled','1');
          });
        }
      });
    }

    // Market buy
    const marketBody = el('tywMarketBody');
    if(marketBody){
      q.filter(it=>it.tab==='market').forEach(it=>{
        const id = String(it.entityId||'');
        if(!id) return;
        const btn = marketBody.querySelector(`button[data-buy="${CSS.escape(id)}"]`);
        if(!btn) return;
        const tr = btn.closest('tr');
        if(tr){
          tr.classList.add('slbMktRowPending');
          if(it.state==='failed') tr.classList.add('slbMktRowFailed');
        }
        const cell = btn.parentElement;
        if(cell) insertPill(cell, it.state, it.requestId);
        if(it.state==='syncing'){
          btn.disabled = true;
          btn.setAttribute('data-slb-mkt-disabled','1');
        }
      });
    }

    // Orders
    const ordersBody = el('tywOrdersBody');
    if(ordersBody){
      q.filter(it=>it.tab==='orders').forEach(it=>{
        const id = String(it.entityId||'');
        if(!id) return;
        const btn = ordersBody.querySelector(`button[data-ocancel="${CSS.escape(id)}"],button[data-orecv="${CSS.escape(id)}"]`);
        if(!btn) return;
        const tr = btn.closest('tr');
        if(tr){
          tr.classList.add('slbMktRowPending');
          if(it.state==='failed') tr.classList.add('slbMktRowFailed');
        }
        const cell = btn.parentElement;
        if(cell) insertPill(cell, it.state, it.requestId);
        if(it.state==='syncing'){
          tr && tr.querySelectorAll('button').forEach(b=>{
            b.disabled = true;
            b.setAttribute('data-slb-mkt-disabled','1');
          });
        }
      });
    }

    // Sales
    const salesBody = el('tywSalesBody');
    if(salesBody){
      q.filter(it=>it.tab==='sales').forEach(it=>{
        const id = String(it.entityId||'');
        if(!id) return;
        const btn = salesBody.querySelector(`button[data-saccept="${CSS.escape(id)}"],button[data-sdeliv="${CSS.escape(id)}"]`);
        if(!btn) return;
        const tr = btn.closest('tr');
        if(tr){
          tr.classList.add('slbMktRowPending');
          if(it.state==='failed') tr.classList.add('slbMktRowFailed');
        }
        const cell = btn.parentElement;
        if(cell) insertPill(cell, it.state, it.requestId);
        if(it.state==='syncing'){
          tr && tr.querySelectorAll('button').forEach(b=>{
            b.disabled = true;
            b.setAttribute('data-slb-mkt-disabled','1');
          });
        }
      });
    }
  }

  function attachObservers(){
    ['tywMyOffersBody','tywMarketBody','tywOrdersBody','tywSalesBody'].forEach(id=>{
      const n = el(id);
      if(!n) return;
      const mo = new MutationObserver(()=>{ applyPendingPills(); });
      mo.observe(n, { childList:true, subtree:true });
    });
  }

  // ===== Data helpers =====
  function toNum(v){
    const x = Number(String(v||'').trim());
    return Number.isFinite(x) ? x : NaN;
  }
  function toInt(v){
    const n = parseInt(String(v||'').trim(), 10);
    return Number.isFinite(n) ? n : NaN;
  }
  function normalizeOffer(o){
    const status = String(o.status || '').trim().toUpperCase();
    return {
      offerId: String(o.offerId || '').trim(),
      title: String(o.title || '').trim(),
      desc: String(o.description || '').trim(),
      price: Number(o.price || 0),
      stock: Number(o.qty || 0),
      enabled: (status ? (status === 'PUBLISHED') : true),
      status: status || 'PUBLISHED'
    };
  }

  function splitOfferDescriptionForEdit_(raw){
    const txt = String(raw || '').replace(/\r\n/g, '\n').trim();
    if(!txt) return { desc:'', delivery:'' };
    const marker = '\n\nDelivery / Contact:\n';
    const marker2 = 'Delivery / Contact:\n';
    const idx = txt.lastIndexOf(marker);
    if(idx >= 0) return { desc: txt.slice(0, idx).trim(), delivery: txt.slice(idx + marker.length).trim() };
    if(txt.indexOf(marker2) === 0) return { desc:'', delivery: txt.slice(marker2.length).trim() };
    return { desc: txt, delivery:'' };
  }
  function offerFormSetEditing_(offer){
    const o = normalizeOffer(offer || {});
    const parts = splitOfferDescriptionForEdit_(o.desc || '');
    try{ if(el('tywOfferTitle')) el('tywOfferTitle').value = String(o.title || ''); }catch(_e){}
    try{ if(el('tywOfferDesc')) el('tywOfferDesc').value = String(parts.desc || ''); }catch(_e){}
    try{ if(el('tywOfferDelivery')) el('tywOfferDelivery').value = String(parts.delivery || ''); }catch(_e){}
    try{ if(el('tywOfferPrice')) el('tywOfferPrice').value = String(Number.isFinite(Number(o.price)) ? Number(o.price) : ''); }catch(_e){}
    try{ if(el('tywOfferQty')) el('tywOfferQty').value = String(Number.isFinite(Number(o.stock)) ? Number(o.stock) : 1); }catch(_e){}
    try{
      const btn = el('tywOfferPostBtn');
      if(btn){
        btn.setAttribute('data-edit-offer-id', String(o.offerId || ''));
        btn.textContent = 'Update Offer';
      }
    }catch(_e){}
    try{ flashOk('offer', 'Editing offer. Update the fields and click Update Offer.'); }catch(_e){}
  }
  function offerFormClearEditing_(){
    try{
      const btn = el('tywOfferPostBtn');
      if(btn){
        btn.removeAttribute('data-edit-offer-id');
        btn.textContent = 'Post Offer';
      }
    }catch(_e){}
  }

  function getOfferById(offerId){
    const api = getApi();
    const list = (api && api.S && api.S.p3 && Array.isArray(api.S.p3.mineOffers)) ? api.S.p3.mineOffers : [];
    return list.map(normalizeOffer).find(x => x.offerId === offerId) || null;
  }

  function pickPayAccountId(){
    const api = getApi();
    const S = api ? api.S : null;
    const prof = (S && S.dash && S.dash.profile) ? S.dash.profile : null;
    const canSpend = !!(prof && (prof.isAdmin || prof.canCreatePouches));
    if(!canSpend) throw new Error('Spending is not enabled. You are in Saving/Receive mode.');

    const accounts = (S && S.dash && Array.isArray(S.dash.accounts)) ? S.dash.accounts : [];
    function isOnHand(a){
      const name = String((a && (a.name||a.accountName||''))||'').trim().toLowerCase();
      return (name === 'on hand' || name === 'onhand');
    }
    function displayName(name){
      const t = String(name||'').trim();
      return t || 'Cosmic Pouch';
    }
    function money(n){
      const v = Number(n||0);
      return (Math.round(v*100)/100).toString();
    }

    const pouches = accounts.filter(a => a && !isOnHand(a) && String(a.status||'ACTIVE').toUpperCase() === 'ACTIVE');
    if(!pouches.length) throw new Error('You need at least 1 Cosmic Pouch to buy. Transfer stones into a pouch first.');

    if(pouches.length === 1){
      return String(pouches[0].accountId || pouches[0].walletId || '');
    }

    const lines = pouches.map((p,i)=> (i+1) + ') ' + displayName(p.name) + ' — bal ' + money(p.balance));
    const pick = prompt('Pay from which Cosmic Pouch? Enter number:\n' + lines.join('\n'), '1');
    if(pick == null) return null;
    const n = parseInt(String(pick).trim(), 10);
    if(!Number.isFinite(n) || n < 1 || n > pouches.length) throw new Error('Invalid selection.');
    const p = pouches[n-1];
    return String(p.accountId || p.walletId || '');
  }

  // ===== Sync runner =====
  // V4.9: queued Market writes are event/state-driven. There is no permanent
  // 1.2s/5s poller while the queue is empty or waiting for user action.
  let syncing = false;
  let runnerTimer = null;

  function hasSyncingQueue_(){
    try{ return loadQueue().some(it => it && it.state === 'syncing'); }catch(_e){ return false; }
  }

  function sweepStuck_(){
    try{
      const q = loadQueue();
      const t = now();
      let changed = false;
      for(const it of q){
        if(!it || it.state !== 'syncing') continue;
        const st = Number(it.startedAt || 0);
        if(st && (t - st) > STUCK_MS){
          it.state = 'failed';
          it.err = 'Backend timeout';
          changed = true;
        }
      }
      if(changed){ saveQueue(q); updateTabIndicators(); }
      return changed;
    }catch(_e){ return false; }
  }

  function scheduleQueuedWork_(delay){
    if(runnerTimer || syncing || !hasApi()) return;
    sweepStuck_();
    if(!hasSyncingQueue_()) return;
    runnerTimer = setTimeout(function(){
      runnerTimer = null;
      syncNext(false);
    }, Math.max(0, Number(delay)||0));
  }

  function stopQueuedWork_(){
    if(runnerTimer){ clearTimeout(runnerTimer); runnerTimer = null; }
  }

  async function callQueued(item){
    const api = getApi();
    if(!api || !api.rpcTryCached) throw new Error('API not ready.');
    if(!api.S || !api.S.token){
      // Re-hydrate token once (some pages open in a fresh sessionStorage context)
      try{
        if(api && api.S && !api.S.token){
          let tok = "";
          try{ tok = String(sessionStorage.getItem("tyw_token")||""); }catch(_e1){}
          if(!tok){
            try{
              const raw = localStorage.getItem("ty_auth_v1") || "";
              if(raw){
                const j = JSON.parse(raw);
                if(j && j.token) tok = String(j.token||"");
              }
            }catch(_e2){}
          }
          if(tok){
            api.S.token = tok;
            try{ sessionStorage.setItem("tyw_token", tok); }catch(_e3){}
          }
        }
      }catch(_e0){}
    }
    if(!api.S || !api.S.token) throw new Error('Session expired. Please log in again.');


    // Execute queued action
    if(item.kind === 'trycached'){
      return await api.rpcTryCached(item.cacheKey, item.candidates || [], item.args || {}, { requestId: item.requestId });
    }
    if(item.kind === 'rpc'){
      return await api.rpc(item.action, item.args || {}, { requestId: item.requestId });
    }
    throw new Error('Unknown queue item.');
  }

  async function afterSuccess(item){
    const api = getApi();
    if(!api) return;

    // Loaders (best-effort)
    const after = Array.isArray(item.after) ? item.after : [];
    for(const fn of after){
      try{
        if(fn === 'refreshDashboardLite' && api.refreshDashboardLite) await api.refreshDashboardLite();
        else if(fn === 'loadMyOffers' && api.loadMyOffers) await api.loadMyOffers();
        else if(fn === 'loadMarket' && api.loadMarket) await api.loadMarket();
        else if(fn === 'loadMyOrders' && api.loadMyOrders) await api.loadMyOrders();
        else if(fn === 'loadMySales' && api.loadMySales) await api.loadMySales();
      }catch(_e){}
    }
  }

  // Some failures are "permanent" and should NOT trap the UI in a resync loop.
  // Example: buying an offer that is already sold out / insufficient stock.
  function isPermanentFail(item, msg){
    const m = String(msg||'').toLowerCase();
    const key = String(item && (item.cacheKey || item.action) || '').toLowerCase();
    if(key.includes('ordercreate') || key.includes('p3_ordercreate')){
      // Typical sold-out / stock exhaustion messages
      if(
        m.includes('out of stock') ||
        m.includes('sold out') ||
        m.includes('sold_out') ||
        m.includes('insufficient stock') ||
        m.includes('not enough stock') ||
        m.includes('no stock') ||
        m.includes('offer is not available') ||
        m.includes('not available') ||
        m.includes('not enough quantity') ||
        m.includes('quantity left') ||
        m.includes('not enough quantity left')
      ){
        return true;
      }
      // Some scripts only return "stock" / "qty" / "quantity" errors
      if((m.includes('stock') || m.includes('qty') || m.includes('quantity')) && (m.includes('insufficient') || m.includes('not enough') || m.includes('unavailable'))){
        return true;
      }
    }
    // Offer already gone / already processed
    if(m.includes('not found') && (key.includes('order') || key.includes('offer') || key.includes('sale'))){
      return true;
    }
    return false;
  }

  async function syncNext(force){
    if(syncing) return;
    if(!hasApi()) return;

    sweepStuck_();
    const q = loadQueue();
    const idx = q.findIndex(it => it && (it.state === 'syncing' || (force && it.state === 'failed')));
    if(idx < 0) return;

    const item = q[idx];
    syncing = true;

    // Make sure Phase 3 (Market) is enabled before running queued writes.
    try{
      const api = getApi();
      if(api && api.ensurePhase3ForTab && item && item.tab){
        await api.ensurePhase3ForTab(item.tab);
      }
    }catch(_e){}

    // Ensure it's marked syncing in storage (if resync)
    if(item.state !== 'syncing'){
      item.state = 'syncing';
      item.err = '';
      item.startedAt = now();
      saveQueue(q);
      updateTabIndicators();
    }
    if(!item.startedAt) queueUpdate(item.requestId, { startedAt: now() });

    try{
      await withTimeout(callQueued(item), CALL_TIMEOUT_MS, 'Backend timeout');
      queueRemove(item.requestId);
      await afterSuccess(item);
      // Final message flash
      if(item.tab && item.okMsg) flashOk(item.tab, item.okMsg);
    }catch(e){
      const msg = (e && e.message) ? e.message : String(e||'');
      // Permanent failures should be removed so they don't block the tab forever.
      if(isPermanentFail(item, msg)){
        queueRemove(item.requestId);
        try{
          const api = getApi();
          // Refresh list to undo any optimistic stock tweaks
          if(api && item.tab === 'market' && api.loadMarket) await api.loadMarket();
        }catch(_e){}
        if(item.tab){
          const nice = (msg && msg.length) ? msg : 'This action cannot be completed.';
          flashErr(item.tab, nice + ' (Removed from queue.)');
        }
      }else{
        queueUpdate(item.requestId, { state:'failed', err: msg });
        if(item.tab){
          flashErr(item.tab, (item.failMsg ? item.failMsg + ' ' : '') + 'Not synced. Click Resync.');
        }
      }
    }finally{
      syncing = false;
      if(hasSyncingQueue_()) scheduleQueuedWork_(0);
      else stopQueuedWork_();
    }
  }

  function startRunner(){
    sweepStuck_();
    scheduleQueuedWork_(0);
    try{
      window.addEventListener('online', function(){ scheduleQueuedWork_(0); });
      window.addEventListener('storage', function(ev){
        if(ev && ev.key === LS_KEY){
          updateTabIndicators();
          if(hasSyncingQueue_()) scheduleQueuedWork_(0); else stopQueuedWork_();
        }
      });
    }catch(_e){}
  }

  // ===== Intercept UI actions (capture phase) =====
  function intercept(){
    document.addEventListener('click', function(ev){
      if(!hasApi()) return;

      const t = ev.target;

      // Retry pill
      const pill = t && t.closest ? t.closest('[data-slb-mkt-resync]') : null;
      if(pill){
        const rid = pill.getAttribute('data-slb-mkt-resync');
        if(rid){
          ev.preventDefault(); ev.stopPropagation();
          queueUpdate(rid, { state:'syncing', err:'' });
          syncNext(true);
        }
        return;
      }

      // Reload buttons -> Resync if failed
      const btn = t && t.closest ? t.closest('button') : null;
      if(btn){
        const id = btn.id || '';

        // Offer reload
        if(id === 'tywOfferReloadBtn'){
          if(tabHasFailed('offer')){ ev.preventDefault(); ev.stopPropagation(); resyncTab('offer'); }
          return;
        }
        if(id === 'tywMarketReloadBtn'){
          if(tabHasFailed('market')){ ev.preventDefault(); ev.stopPropagation(); resyncTab('market'); }
          return;
        }
        if(id === 'tywOrdersReloadBtn'){
          if(tabHasFailed('orders')){ ev.preventDefault(); ev.stopPropagation(); resyncTab('orders'); }
          return;
        }
        if(id === 'tywSalesReloadBtn'){
          if(tabHasFailed('sales')){ ev.preventDefault(); ev.stopPropagation(); resyncTab('sales'); }
          return;
        }

        // Post Offer
        if(id === 'tywOfferPostBtn'){
          ev.preventDefault(); ev.stopPropagation();

          const editingOfferId = String((el('tywOfferPostBtn') && el('tywOfferPostBtn').getAttribute('data-edit-offer-id')) || '').trim();
          const title = String((el('tywOfferTitle') && el('tywOfferTitle').value) || '').trim();
          const desc = String((el('tywOfferDesc') && el('tywOfferDesc').value) || '').trim();
          const delivery = String((el('tywOfferDelivery') && el('tywOfferDelivery').value) || '').trim();
          const price = toNum((el('tywOfferPrice') && el('tywOfferPrice').value) || '');
          const stock = toInt((el('tywOfferQty') && el('tywOfferQty').value) || '');

          if(!title) return flashErr('offer', 'Title required.');
          if(!Number.isFinite(price) || price <= 0) return flashErr('offer', 'Price must be > 0.');
          if(!Number.isFinite(stock) || stock < 0) return flashErr('offer', 'Invalid stock.');

          const description = delivery
            ? (desc ? (desc + "\n\nDelivery / Contact:\n" + delivery) : ("Delivery / Contact:\n" + delivery))
            : desc;

          if(description.length > 1000){
            return flashErr('offer', 'Description too long (max 1000).');
          }

          // Optimistic: clear inputs + queue
          try{ el('tywOfferTitle').value = ''; }catch(_e){}
          try{ el('tywOfferDesc').value = ''; }catch(_e){}
          try{ el('tywOfferDelivery').value = ''; }catch(_e){}
          try{ el('tywOfferPrice').value = ''; }catch(_e){}
          try{ el('tywOfferQty').value = '1'; }catch(_e){}

          const requestId = genId();
          if(editingOfferId){
            const cur = getOfferById(editingOfferId);
            if(!cur) return flashErr('offer', 'Offer not found (reload list).');
            const status = cur.enabled ? 'PUBLISHED' : 'DRAFT';
            queueAdd({
              requestId,
              tab: 'offer',
              kind: 'trycached',
              cacheKey: 'p3_offerSetPrice',
              candidates: (getApi().P3 && getApi().P3.offerSetPrice) ? getApi().P3.offerSetPrice : [],
              args: { offerId: editingOfferId, title, description, price, qty: stock, status },
              after: ['loadMyOffers','loadMarket'],
              okMsg: 'Offer updated.',
              failMsg: 'Offer update failed.'
            });
            offerFormClearEditing_();
          }else{
            queueAdd({
              requestId,
              tab: 'offer',
              kind: 'trycached',
              cacheKey: 'p3_offerCreate',
              candidates: (getApi().P3 && getApi().P3.offerCreate) ? getApi().P3.offerCreate : [],
              args: { offerId:'', title, description, price, qty: stock, status:'PUBLISHED' },
              after: ['loadMyOffers','loadMarket'],
              okMsg: 'Offer posted.',
              failMsg: 'Offer failed.'
            });
          }
          applyPendingPills();
          syncNext(true);
          return;
        }

        // My Offers actions
        const myOffersBody = el('tywMyOffersBody');
        if(myOffersBody && myOffersBody.contains(btn)){
          const editId = btn.getAttribute('data-edit');
          const toggleId = btn.getAttribute('data-toggle');
          const saveId = btn.getAttribute('data-save');
          const delId = btn.getAttribute('data-del');

          if(editId){
            ev.preventDefault(); ev.stopPropagation();
            const offerId = String(editId);
            const cur = getOfferById(offerId);
            if(!cur) return flashErr('offer', 'Offer not found (reload list).');
            offerFormSetEditing_(cur);
            return;
          }

          if(toggleId){
            ev.preventDefault(); ev.stopPropagation();
            const offerId = String(toggleId);
            const cur = getOfferById(offerId);
            if(!cur) return flashErr('offer', 'Offer not found (reload list).');
            const newEnabled = !cur.enabled;

            // Optimistic DOM tweak
            try{
              const tr = btn.closest('tr');
              if(tr && tr.children && tr.children[0]){
                tr.children[0].innerHTML = '<span class="pill ' + (newEnabled ? 'on' : 'off') + '">' + (newEnabled ? 'ON' : 'OFF') + '</span>';
              }
              btn.textContent = newEnabled ? 'Disable' : 'Enable';
            }catch(_e){}

            const requestId = genId();
            queueAdd({
              requestId,
              tab: 'offer',
              kind: 'trycached',
              cacheKey: 'p3_offerToggle',
              candidates: (getApi().P3 && getApi().P3.offerToggle) ? getApi().P3.offerToggle : [],
              args: { offerId, enabled: newEnabled },
              after: ['loadMyOffers','loadMarket'],
              okMsg: 'Offer updated.',
              failMsg: 'Offer update failed.'
            });
            applyPendingPills();
            syncNext(true);
            return;
          }

          if(saveId){
            ev.preventDefault(); ev.stopPropagation();
            const offerId = String(saveId);
            const tr = btn.closest('tr');
            const priceInp = tr ? tr.querySelector('input[data-price]') : null;
            const stockInp = tr ? tr.querySelector('input[data-stock]') : null;
            const price = toNum(priceInp ? priceInp.value : '');
            const stock = toInt(stockInp ? stockInp.value : '');
            if(!Number.isFinite(price) || price <= 0) return flashErr('offer', 'Price must be > 0.');
            if(!Number.isFinite(stock) || stock < 0) return flashErr('offer', 'Invalid stock.');

            const cur = getOfferById(offerId);
            if(!cur) return flashErr('offer', 'Offer not found (reload list).');
            const status = cur.enabled ? 'PUBLISHED' : 'DRAFT';

            const requestId = genId();
            queueAdd({
              requestId,
              tab: 'offer',
              kind: 'trycached',
              cacheKey: 'p3_offerSetPrice',
              candidates: (getApi().P3 && getApi().P3.offerSetPrice) ? getApi().P3.offerSetPrice : [],
              args: { offerId, title: cur.title, description: cur.desc || '', price, qty: stock, status },
              after: ['loadMyOffers','loadMarket'],
              okMsg: 'Offer saved.',
              failMsg: 'Offer save failed.'
            });
            applyPendingPills();
            syncNext(true);
            return;
          }

          if(delId){
            ev.preventDefault(); ev.stopPropagation();
            const offerId = String(delId);
            if(!confirm('Delete this offer? It will be removed from Market. Past orders keep history.')) return;

            const requestId = genId();
            queueAdd({
              requestId,
              tab: 'offer',
              kind: 'trycached',
              cacheKey: 'p3_offerDelete',
              candidates: (getApi().P3 && getApi().P3.offerDelete) ? getApi().P3.offerDelete : [],
              args: { offerId },
              after: ['loadMyOffers','loadMarket'],
              okMsg: 'Offer deleted.',
              failMsg: 'Offer delete failed.'
            });
            applyPendingPills();
            syncNext(true);
            return;
          }
        }

        // Market buy
        const marketBody = el('tywMarketBody');
        if(marketBody && marketBody.contains(btn) && btn.hasAttribute('data-buy')){
          ev.preventDefault(); ev.stopPropagation();
          const offerId = String(btn.getAttribute('data-buy') || '');
          const qtyInp = marketBody.querySelector('input[data-buyqty="' + CSS.escape(offerId) + '"]');
          const qty = toInt(qtyInp ? qtyInp.value : '1');
          if(!Number.isFinite(qty) || qty <= 0) return flashErr('market', 'Invalid qty.');

          let payAccountId = '';
          try{
            const picked = pickPayAccountId();
            if(picked == null) return; // user cancelled
            payAccountId = picked;
          }catch(e){
            return flashErr('market', (e && e.message) ? e.message : String(e||''));
          }
          if(!payAccountId) return flashErr('market', 'Pick a Cosmic Pouch to pay from.');

          const requestId = genId();

          // Optimistic: add a "PLACED" row into My Orders immediately
          try{
            const row = btn.closest('tr');
            const titleText = row && row.children && row.children[0] ? String(row.children[0].textContent||'').trim() : ('Offer ' + offerId);
            const sellerText = row && row.children && row.children[1] ? String(row.children[1].textContent||'').trim() : '';
            const priceText = row && row.children && row.children[2] ? String(row.children[2].textContent||'').trim() : '';
            const price = parseFloat(priceText.replace(/[^0-9.\-]/g,'')) || 0;
            const total = Math.round((price * qty) * 100) / 100;

            const ordersBody = el('tywOrdersBody');
            if(ordersBody){
              const tr = document.createElement('tr');
              tr.setAttribute('data-slb-temp-order','1');
              tr.setAttribute('data-slb-request', requestId);
              tr.innerHTML = `
                <td class="slbMktQSmall">Now</td>
                <td>${escapeHtml(titleText)}</td>
                <td>${escapeHtml(sellerText)}</td>
                <td>${qty}</td>
                <td>${total}</td>
                <td data-slb-temp-status="1">PLACED</td>
                <td class="slbMktQSmall">(syncing…)</td>
              `;
              // Put on top
              ordersBody.insertBefore(tr, ordersBody.firstChild);
              const statusCell = tr.querySelector('td[data-slb-temp-status="1"]');
              if(statusCell) insertPill(statusCell, 'syncing', requestId);
            }
          }catch(_e){}

          // Optimistic: reduce stock cell if possible
          try{
            const tr = btn.closest('tr');
            if(tr && tr.children && tr.children[3]){
              const cur = parseInt(String(tr.children[3].textContent||'').trim(), 10);
              if(Number.isFinite(cur)) tr.children[3].textContent = String(Math.max(0, cur - qty));
            }
          }catch(_e){}
          queueAdd({
            requestId,
            tab: 'market',
            kind: 'trycached',
            cacheKey: 'p3_orderCreate',
            candidates: (getApi().P3 && getApi().P3.orderCreate) ? getApi().P3.orderCreate : [],
            args: { offerId, qty, payAccountId },
            after: ['loadMarket','loadMyOrders','refreshDashboardLite'],
            okMsg: 'Order placed. Check My Orders.',
            failMsg: 'Buy failed.'
          });
          applyPendingPills();
          syncNext(true);
          return;
        }

        // Orders actions
        const ordersBody = el('tywOrdersBody');
        if(ordersBody && ordersBody.contains(btn)){
          const cancelId = btn.getAttribute('data-ocancel');
          const recvId = btn.getAttribute('data-orecv');

          if(cancelId){
            ev.preventDefault(); ev.stopPropagation();
            const orderId = String(cancelId||'');
            if(!confirm('Cancel this order?')) return;

            const requestId = genId();
            queueAdd({
              requestId,
              tab: 'orders',
              kind: 'trycached',
              cacheKey: 'p3_orderCancel',
              candidates: (getApi().P3 && getApi().P3.orderCancel) ? getApi().P3.orderCancel : [],
              args: { orderId },
              after: ['loadMyOrders','refreshDashboardLite','loadMarket'],
              okMsg: 'Order cancelled.',
              failMsg: 'Cancel failed.'
            });
            applyPendingPills();
            syncNext(true);
            return;
          }

          if(recvId){
            ev.preventDefault(); ev.stopPropagation();
            const orderId = String(recvId||'');
            if(!confirm('Confirm received? This releases the hold to the seller.')) return;

            const requestId = genId();
            queueAdd({
              requestId,
              tab: 'orders',
              kind: 'trycached',
              cacheKey: 'p3_orderConfirmReceived',
              candidates: (getApi().P3 && getApi().P3.orderConfirmReceived) ? getApi().P3.orderConfirmReceived : [],
              args: { orderId },
              after: ['loadMyOrders','loadMySales','refreshDashboardLite'],
              okMsg: 'Confirmed. Hold released.',
              failMsg: 'Confirm failed.'
            });
            applyPendingPills();
            syncNext(true);
            return;
          }
        }

        // Sales actions
        const salesBody = el('tywSalesBody');
        if(salesBody && salesBody.contains(btn)){
          const accId = btn.getAttribute('data-saccept');
          const delivId = btn.getAttribute('data-sdeliv');

          if(accId){
            ev.preventDefault(); ev.stopPropagation();
            const orderId = String(accId||'');

            const requestId = genId();
            queueAdd({
              requestId,
              tab: 'sales',
              kind: 'trycached',
              cacheKey: 'p3_saleAccept',
              candidates: (getApi().P3 && getApi().P3.saleAccept) ? getApi().P3.saleAccept : [],
              args: { orderId, status:'IN_PROGRESS' },
              after: ['loadMySales'],
              okMsg: 'Accepted. You can deliver now.',
              failMsg: 'Accept failed.'
            });
            applyPendingPills();
            syncNext(true);
            return;
          }

          if(delivId){
            ev.preventDefault(); ev.stopPropagation();
            const orderId = String(delivId||'');

            const requestId = genId();
            queueAdd({
              requestId,
              tab: 'sales',
              kind: 'trycached',
              cacheKey: 'p3_saleMarkDelivered',
              candidates: (getApi().P3 && getApi().P3.saleMarkDelivered) ? getApi().P3.saleMarkDelivered : [],
              args: { orderId, status:'DELIVERED' },
              after: ['loadMySales','loadMyOrders'],
              okMsg: 'Marked delivered. Buyer must confirm.',
              failMsg: 'Update failed.'
            });
            applyPendingPills();
            syncNext(true);
            return;
          }
        }
      }
    }, true);
  }

  function bootstrap(){
    if(!hasApi()){
      setTimeout(bootstrap, 250);
      return;
    }
    attachObservers();
    intercept();
    updateTabIndicators();
    startRunner();
    // If there are any syncing items already saved, kick one immediately
    setTimeout(()=>{ syncNext(true); }, 50);
  }

  bootstrap();
})();
